<template>
  <!--
    Form Checkbox:
      b-form-checkbox:class ==
        .form-group > div > .custom-control.custom-checkbox.gmb-checkbox
      b-form-checkbox > div:class ==
        .form-group > div > .custom-control.custom-checkbox.gmb-checkbox > div
        @click='$event.stopPropagation()'
  -->

  <b-form-checkbox
      class="d-flex mh-0 w-100 pl-0 gmb-checkbox"
      ref="bsCheckbox"
      size="sm"
      :switch="switcherStyle"
      :uncheckedValue="null"
      :value="value"
      @input="
      (bsCheckboxGroupNewActivatedValues) =>
        onActivatedValueChanged(bsCheckboxGroupNewActivatedValues)
    "
      @click.native.stop
  />
</template>

<script>
export default {
  name: "GmbCheckbox",

  components: {},

  props: {
    switcherStyle: Boolean,
    value: String,
  },

  data() {
    return {
      isActivated: undefined,
    };
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
    this.isActivated = this.$refs.bsCheckbox.isChecked;
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    onActivatedValueChanged(bsCheckboxGroupNewActivatedValues) {
      this.isActivated = bsCheckboxGroupNewActivatedValues.includes(this.value);
      this.$emit("state-changed", this.isActivated);
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/settings/dimensions";
@import "@/sass/bootstrap-addons/rounded";

.gmb-checkbox {
  &.custom-control {
    &.custom-checkbox {
      &.custom-control-inline {
        margin-right: unset;
      }

      & *:hover {
        cursor: pointer;
      }

      & > .custom-control-input {
        height: unset;
      }

      & > .custom-control-label {
        display: flex;
        flex-grow: 1;
        width: 0;

        &::before {
          @extend .rounded-1;

          position: unset;

          flex-shrink: 0;
          // border: none;
          width: $gmb-offset-3;
          height: $gmb-offset-3;
        }

        &::after {
          // display: none;
          top: unset;
          left: unset;

          width: $gmb-offset-3;
          height: $gmb-offset-3;
        }
      }
    }

    &.custom-switch {
      &::disabled {
        display: none;
      }

      & *:hover {
        cursor: pointer;
      }

      // & > .custom-control-input {
      //   height: unset;

      //   &:checked ~ .custom-control-label::before {
      //     display: none;
      //   }
      // }

      & > .custom-control-input {
        height: unset;
      }

      & > .custom-control-label {
        display: flex;
        flex-grow: 1;
        width: 0;

        &::before {
          position: unset;

          flex-shrink: 0;
          // border: none;
          width: $gmb-offset-3;
          height: $gmb-offset-3;

          border-radius: $gmb-offset-3;
        }

        &::after {
          top: unset;
          left: 0;

          width: 50%;
          height: 100%;

          border-radius: unset;

          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
        }
      }

      & > .custom-control-input {
        &:checked {
          & ~ .custom-control-label {
            &::after {
              border-top-left-radius: 0;
              border-bottom-left-radius: 0;
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;

              transform: translateX(100%) !important;
            }
          }
        }
      }
    }
  }
}
</style>
